import { Component, EventEmitter, Input, Output, OnDestroy, OnInit, Inject } from '@angular/core';
import { ApplicationFacade, CardsNgrxFacade, CustomerCard, CustomerCardType } from '@ridango/components';
import { AllowedPathService, BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';
import { takeUntil } from 'rxjs/operators';

interface ContextualMenuButton {
    label: string;
    emitFunction: EventEmitter<any>;
    show: boolean;
    actionType: 'danger' | 'normal';
}

@Component({
    selector: 'rwidget-card-contextual-menu',
    templateUrl: './card-contextual-menu.component.html',
    styleUrls: ['card-contextual-menu.component.scss']
})
export class CardContextualMenuComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() card: CustomerCard;
    @Input() mode: 'default' | 'dialog' = 'default';

    @Output() addMoneyClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() editDataClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() unBlockClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() blockClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() removeClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() goToPurchaseFlow: EventEmitter<void> = new EventEmitter<void>();

    assetsPath$ = this.applicationFacade.assetsPath$;
    isWebPurchaseAllowed = this.pathService.isWebPurchaseAllowed();

    actions: ContextualMenuButton[];
    cardType = CustomerCardType;

    constructor(
        private applicationFacade: ApplicationFacade,
        private pathService: AllowedPathService,
        private cardsFacade: CardsNgrxFacade,
        @Inject('ENV') public env: Env
    ) {
        super();
    }

    ngOnInit() {
        this.cardsFacade
            .getCardById(this.card?.id)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((card) => {
                const actions: ContextualMenuButton[] = [
                    {
                        label: 'BUY_TICKET',
                        emitFunction: this.goToPurchaseFlow,
                        show:
                            (!!this.env.PURCHASE_FLOW || !!this.env.PURCHASE) &&
                            !this.env.RELATED_CARD?.HIDE_BUY_TICKET,
                        actionType: 'normal'
                    },
                    {
                        label: 'CARD_ACTION_EDIT',
                        emitFunction: this.editDataClick,
                        show: card?.relatedCardId && !card?.blocked,
                        actionType: 'normal'
                    },
                    {
                        label: 'UNBLOCK_CARD',
                        emitFunction: this.unBlockClick,
                        show:
                            card?.blocked &&
                            card?.cardType !== this.cardType.EMV &&
                            this.env.RELATED_CARD?.ALLOW_UNBLOCK,
                        actionType: 'danger'
                    },
                    {
                        label: 'CARD_BLOCKING_MODAL_BUTTON',
                        emitFunction: this.blockClick,
                        show:
                            !card?.blocked &&
                            card?.cardType !== this.cardType.EMV &&
                            !this.env.RELATED_CARD?.DISALLOW_BLOCK,
                        actionType: 'danger'
                    },
                    {
                        label: 'REMOVE_CARD',
                        emitFunction: this.removeClick,
                        show: !!card?.relatedCardId,
                        actionType: 'danger'
                    }
                ];
                this.actions = actions.filter((a) => a.show);
            });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
